import type { ReactElement } from 'react';
import { getShadowAiCategoryLabel } from '@kirin/api-client/contracts/shadow-ai';
import { Badge } from '@/components/ui/badge';

export function CategoryBadge({
  category,
}: {
  category: string;
}): ReactElement {
  const label = getShadowAiCategoryLabel(category);
  return (
    <Badge variant="secondary" className="text-xs">
      {label}
    </Badge>
  );
}
